import React, { Component } from "react";
import PMIICDateRangePicker from "../../component/PMIICDateRangePicker";
import isFunction from "lodash/isFunction";
import { Prev } from "react-bootstrap/PageItem";
import { PRAGATIdateFormat } from "../../helper";
let startTimestamp = null;
let endTimestamp = null;

class PragatiCalendarFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cal: false,
      show: false,
      date: {},
      calendarDatedisplay: "- Meeting Date -"
    };
  }

  // componentDidMount() {
  //   const { defaultDates } = this.props;
  //   if (defaultDates && defaultDates.createdDate) {
  //     startTimestamp = defaultDates.createdDate.from;
  //     endTimestamp = defaultDates.createdDate.to;
  //     this.setState(
  //       {
  //         date: { start: startTimestamp, end: endTimestamp },
  //         displayText: defaultDates.displayText
  //       },
  //       () => {
  //         this.onSubmit();
  //       }
  //     );
  //   }
  // }

  // componentWillReceiveProps(nextProps, nextContext) {
  //   const { defaultDates } = nextProps;
  //   const { defaultDates: oldDefaultDates } = this.props;
  //   if (defaultDates !== oldDefaultDates) {
  //     this.setState({
  //       date: defaultDates,
  //       displayText: defaultDates.displayText || "- Created Date -"
  //     });
  //   }
  // }

  onHandleCal = () => {
    const { cal } = this.state;
    this.setState({
      cal: !cal
    });
  };

  handleSelect = (range, initial) => {
    let date = new Date(startTimestamp);
    let startDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    startDate.setHours(0, 0, 0);
    range.startDate.setHours(0, 0, 0);
    range.endDate.setHours(23, 59, 59, 999);
    startTimestamp = Date.parse(range.startDate);
    endTimestamp = Date.parse(range.endDate);
    this.setState(
      {
        date: { start: range.startDate, end: range.endDate },
        range,
        displayText:
          this.GetFormattedDate(startTimestamp) +
          " to " +
          this.GetFormattedDate(endTimestamp)
      },
      () => {
        if (this.props.getFilterArrayValue) {
          const { filterArray } = this.props;
          this.props.getFilterArrayValue(filterArray, this.state.displayText);
        }
        if (this.props.onChange) {
          this.props.onChange({
            createdDate: { from: startTimestamp, to: endTimestamp },
            dates: this.state.displayText,
            sortOrder: "ASC"
          });
        }
      }
    );
  };

  handleClose = () => {
    this.setState(prevState => ({
      show: false,
      cal: false,
      displayText: this.props.isDashboard ? "All" : prevState.displayText
    }));
  };

  handleShow = () => {
    this.setState({
      show: true,
      cal: false
    });
  };

  GetFormattedDate = date => {
    let todayTime = new Date(date);
    let month = todayTime.getMonth() + 1;
    let day = todayTime.getDate();
    let year = todayTime.getFullYear();
    return month + "/" + day + "/" + year;
  };

  onSubmit = ranges => {
    const { onChange } = this.props;
    if (ranges) {
      this.handleSelect(ranges);
    } else {
      onChange({
        createdDate: { from: startTimestamp, to: endTimestamp },
        dates: this.state.displayText,
        sortOrder: "ASC"
      });
    }

    this.setState({
      show: false,
      cal: false
    });
  };

  handleSort = option => {
    this.setState({ calendarDatedisplay: option.title });
    const {
      calenderOptions,
      onCalenderChange,
      calenderDisplaytext
    } = this.props;
    //console.log(calenderOptions)
    const filteredMeetings = calenderOptions.filter(
      meeting =>
        PRAGATIdateFormat(meeting.meetingDateTimeStamp) === option.title
    );
    //console.log(filteredMeetings)
    if (option.value == "All") {
      onCalenderChange(calenderOptions, true);
    } else {
      onCalenderChange(filteredMeetings, true, option.title, option.value);
    }
  };

  onChangeSort = ({ value: name, title: text }) => {
    let { onChange } = this.props;
    let currentTimeStamp = Date.parse(new Date());
    const date = new Date();
    let createdDate = {};
    switch (name) {
      case "All":
        createdDate = {
          from: Date.parse(new Date(2013, 1, 1)),
          to: currentTimeStamp
        };
        break;

      case "currentMonth":
        createdDate = {
          from: Date.parse(new Date(date.getFullYear(), date.getMonth(), 1)),
          to: currentTimeStamp
        };
        break;
      case "7":
        date.setDate(date.getDate() - 7);
        createdDate = {
          from: Date.parse(date),
          to: currentTimeStamp
        };
        break;
      case "30":
        date.setDate(date.getDate() - 30);
        createdDate = {
          from: Date.parse(date),
          to: currentTimeStamp
        };
        break;
      case "180":
        date.setDate(date.getDate() - 180);
        createdDate = {
          from: Date.parse(date),
          to: currentTimeStamp
        };
        break;
      case "PMG Merger":
        createdDate = {
          from: Date.parse("Feb 14, 2019"),
          to: currentTimeStamp
        };
        break;
      case "365":
        const fullCurrentYear = new Date(date.getFullYear(), 0, 1);
        createdDate = {
          from: Date.parse(fullCurrentYear),
          to: currentTimeStamp
        };
        break;
      default:
        break;
    }
    this.setState(
      {
        cal: false,
        displayText: text,
        range: null
      },
      () => {
        isFunction(onChange) && onChange({ createdDate, dates: text });
      }
    );
  };

  render() {
    const { cal, show, range, calendarDatedisplay } = this.state;
    const {
      displayDateTitle = "All",
      calenderOptions = [],
      calenderDisplaytext,
      searchValue
    } = this.props;
    const newArray = calenderOptions.map(item => {
      return {
        title: PRAGATIdateFormat(item.meetingDate),
        value: item.meetingDateTimeStamp
      };
    });
    const uniqueArray = [
      ...new Set(newArray.map(item => JSON.stringify(item)))
    ].map(item => JSON.parse(item));
    //const newObject = { title: "All", value: "All" };
    //const updatedData = [newObject, ...uniqueArray];
    const uniqueByTitle = uniqueArray.reduce((acc, current) => {
      const existing = acc.find(obj => obj.title === current.title);
      if (!existing) {
        acc.push(current);
      }
      return acc;
    }, []);
    //   if(searchValue){
    //     uniqueByTitle.shift()
    //   }
    //console.log(uniqueByTitle);
    return (
      <React.Fragment>
        <div
          className={`dropdown field-calendar-filter ${
            cal ? "visible" : "hidden"
          }`}
          onClick={this.onHandleCal}
          style={{ marginRight: "-2px" }}
        >
          <div className={`dropdown-overlay ${cal ? "visible" : ""}`} />
          <div
            className="dropdown-selected-value"
            style={{
              width: displayDateTitle == "- Meeting Date -" ? 215 : 280
            }}
          >
            {displayDateTitle == "- Meeting Date -" && !calenderDisplaytext
              ? calendarDatedisplay
              : displayDateTitle}
          </div>
          <div
            className="dropdown-option-list"
            style={{
              width: displayDateTitle == "- Meeting Date -" ? "93%" : null,
              height:
                displayDateTitle == "- Meeting Date -" &&
                uniqueByTitle.length > 4
                  ? "12em"
                  : "auto",
              overflow: displayDateTitle == "- Meeting Date -" ? "auto" : null
            }}
          >
            {displayDateTitle == "- Meeting Date -" ? (
              <>
                {uniqueByTitle.map(option => {
                  return option.value ? (
                    <div
                      onClick={e => {
                        this.handleSort(option);
                      }}
                    >
                      {option.title}
                    </div>
                  ) : (
                    <div onClick={this.handleShow}>{option.title}</div>
                  );
                })}
              </>
            ) : (
              <>
                {calenderOptions.map(option => {
                  return option.value ? (
                    <div
                      onClick={e => {
                        this.onChangeSort(option);
                      }}
                    >
                      {option.title}
                    </div>
                  ) : (
                    <div onClick={this.handleShow}>{option.title}</div>
                  );
                })}
              </>
            )}
          </div>
        </div>
        {(show && (
          <PMIICDateRangePicker
            show={show}
            handleSelect={this.handleSelect}
            range={range}
            onSubmit={this.onSubmit}
            handleClose={this.handleClose}
          />
        )) ||
          null}
      </React.Fragment>
    );
  }
}

export default PragatiCalendarFilter;
